<template>
  <v-container grid-list-md fluid pa-0>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card class="px-2">
          <v-card-title>
            <span class="title">{{formTitle}}</span>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-form v-model="valid" ref="form">
              <v-container grid-list-md fluid>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedDrug.name"
                      :rules="[required]"
                      label="Name"
                      required
                      name="name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedDrug.route"
                      :rules="[required]"
                      label="Route"
                      required
                      name="route"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedDrug.duration"
                      :rules="[required]"
                      label="Duration"
                      required
                      name="duration"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-text-field
                      v-model="editedDrug.usage"
                      :rules="[required]"
                      label="Usage"
                      required
                      name="usage"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedDrug.type"
                      :rules="[required]"
                      label="Type"
                      required
                      name="type"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedDrug.price"
                      name="price"
                      :rules="[required]"
                      label="Price"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="text-xs-right">
                    <v-spacer></v-spacer>
                    <v-btn flat @click="close">Cancel</v-btn>
                    <v-btn
                      class="mx-0"
                      :disabled="!valid"
                      :loading="saving"
                      color="primary"
                      @click="save"
                    >Save</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout
      row
      wrap
      align-center
      justify-end
      :class="{'rt-5': $vuetify.breakpoint.name !== 'xs'}"
      
    >
      <v-flex xs12 sm6 md4 mx-2 class="pointer-event-auto">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          label="Search"
          v-model="search"
          hide-details
          single-line
          outline
          class="rounded"
        >
          <v-tooltip top slot="append-outer">
            <v-icon
              class="mx-2"
              medium
              slot="activator"
              @click="dialog = true"
              color="secondary"
            >mdi-plus-circle</v-icon>

            <span>New Drug</span>
          </v-tooltip>
        </v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-data-table
          :search="search"
          :headers="headers"
          :items="drugs"
          disable-initial-sort
          :rows-per-page-items="per_page"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td>{{props.item.id}}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.route }}</td>
              <td>{{ props.item.duration }}</td>
              <td>{{ props.item.usage }}</td>
              <td>{{ props.item.type }}</td>
              <td>{{ props.item.price }}</td>

              <td>
                <v-tooltip top>
                  <v-icon
                    slot="activator"
                    class="mx-1"
                    @click="confirmDelete(props.item)"
                  >mdi-delete-outline</v-icon>
                  <span>Delete</span>
                </v-tooltip>

                <v-tooltip top>
                  <v-icon
                    slot="activator"
                    class="mx-1"
                    @click="editDrug(props.item)"
                  >mdi-pencil-outline</v-icon>
                  <span>Edit</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  middleware: "admin",
  data() {
    return {
      drug: {},
      required: v => !!v || "This field is required.",
      valid: true,
      defaultDrug: {
        name: "",
        route: "",
        duration: "",
        usage: "",
        type: "",
        price: ""
      },
      editedDrug: {
        name: "",
        route: "",
        duration: "",
        usage: "",
        type: "",
        price: ""
      },
      search: "",
      editedIndex: -1,
      dialog: false,
      saving: false,
      headers: [
        { text: "#", value: "id" },
        { text: "Drug Name", value: "name" },
        { text: "Route", value: "route" },
        { text: "Duration", value: "duration" },
        { text: "Usage", value: "usage" },
        { text: "Type", value: "type" },
        { text: "Price", value: "price" },
        { text: "", value: "name", sortable: false, width: 200 }
      ]
    };
  },
  computed: {
    drugs() {
      return this.$store.getters["base/drugs"];
    },
    formTitle() {
      return this.editedIndex === -1 ? "Add New Drug" : "Edit Drug";
    }
  },

  methods: {
    close() {
      this.saving = false;
      this.dialog = false;
      this.$refs.form.reset();
      Object.assign(this.editedDrug, this.defaultDrug);
      this.editedIndex = -1;
    },

    async save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        if (this.editedIndex > -1) {
          await this.axios.put(
            `api/drugs/${this.editedDrug.id}`,
            this.editedDrug
          )
          .finally(() => {
            this.saving = false;
          });
        } else {
          await this.axios.post("api/drugs", this.editedDrug)
          .finally(() => {
            this.saving = false;
          });
        }

        this.$store.dispatch("base/loadDrugs", true);
        this.close();
      }
    },

    editDrug(drug) {
      this.editedIndex = drug.id;
      Object.assign(this.editedDrug, drug);
      this.dialog = true;
    },

    confirmDelete(drug) {
      const params = {
        title: `Delete "${drug.name}"`,
        message: `Are you sure, you want to delete the drug "${drug.name}"?`,
        // typeText: true,
        mode: "delete",
        onConfirm: () => this.deleteDrug(drug)
      };

      this.$modal.show(params);
    },

    deleteDrug(drug) {
      this.axios
        .delete(`api/drugs/${drug.id}`)
        .then(result => {
          this.$store.dispatch("base/loadDrugs", true);
        })
        .catch(err => {
          this.$snackbar.error("Could not delete this drug.");
        });
    }
  },
  mounted() {
    this.$store.dispatch("base/loadDrugs");
  }
};
</script>

<style scoped>
</style>